import * as React from "react";
import { AllChartsData } from "../hooks/useAllChartsData";

interface AllChartsDataContextValue {
  allChartsData?: AllChartsData;
  allOrderNames?: string[];
  isLoading?: boolean;
  error?: unknown;
}

const AllChartsDataContext = React.createContext<AllChartsDataContextValue>({
  allChartsData: undefined,
  allOrderNames: undefined,
  isLoading: false,
  error: undefined,
});

export const useAllChartsDataContext = () =>
  React.useContext(AllChartsDataContext);

interface AllChartsDataProviderProps {
  children: React.ReactNode;
  allChartsData?: AllChartsData;
  allOrderNames?: string[];
  isLoading?: boolean;
  error?: unknown;
}

export const AllChartsDataProvider: React.FC<AllChartsDataProviderProps> = ({
  children,
  allChartsData,
  allOrderNames,
  isLoading,
  error,
}) => {
  return (
    <AllChartsDataContext.Provider
      value={{ allChartsData, allOrderNames, isLoading, error }}
    >
      {children}
    </AllChartsDataContext.Provider>
  );
};
